import{useEffect as t}from"react";var o=function(o){var r=o.context,n=o.returnToRoute,a=r.authError,e=r.isAuthenticated,i=r.isLoading,u=r.login;t((function(){i||e||a||u(n)}),[a,e,i,u,n])};export{o as default};
//# sourceMappingURL=useAuthenticationRequired.js.map
